module.exports = __webpack_public_path__ + "static/media/mode-31.83ffb40c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Workspace/Tools/GgbIcons/mode-31.svg
// module id = 1004
// module chunks = 2